export function MacroDonut({ label, calories, protein, carbs, fat, color, size = 100, pL = "P", kL = "K", fL = "F" }) {
  const total = protein + carbs + fat;
  if (total === 0) {
    return (
      <div className="flex flex-col items-center gap-1">
        <svg width={size} height={size} viewBox="0 0 100 100">
          <circle cx="50" cy="50" r="40" fill="none" stroke="#e2e8f0" strokeWidth="12" />
          <text x="50" y="48" textAnchor="middle" className="text-[11px] font-bold fill-slate-400">0</text>
          <text x="50" y="60" textAnchor="middle" className="text-[7px] fill-slate-400">kcal</text>
        </svg>
        <span className="text-[10px] font-semibold text-slate-500 text-center leading-tight">{label}</span>
      </div>
    );
  }
  const pPct = (protein / total) * 100;
  const cPct = (carbs / total) * 100;
  const circumference = 2 * Math.PI * 40;
  const pLen = (pPct / 100) * circumference;
  const cLen = (cPct / 100) * circumference;
  const fLen = circumference - pLen - cLen;

  return (
    <div className="flex flex-col items-center gap-1">
      <svg width={size} height={size} viewBox="0 0 100 100">
        <circle cx="50" cy="50" r="40" fill="none" stroke="#e2e8f0" strokeWidth="12" />
        <circle cx="50" cy="50" r="40" fill="none" stroke="#3b82f6" strokeWidth="12"
          strokeDasharray={`${pLen} ${circumference - pLen}`} transform="rotate(-90 50 50)" />
        <circle cx="50" cy="50" r="40" fill="none" stroke="#f59e0b" strokeWidth="12"
          strokeDasharray={`${cLen} ${circumference - cLen}`} strokeDashoffset={`${-pLen}`} transform="rotate(-90 50 50)" />
        <circle cx="50" cy="50" r="40" fill="none" stroke="#f43f5e" strokeWidth="12"
          strokeDasharray={`${fLen} ${circumference - fLen}`} strokeDashoffset={`${-(pLen + cLen)}`} transform="rotate(-90 50 50)" />
        <text x="50" y="46" textAnchor="middle" className="text-[12px] font-bold" fill={color}>{Math.round(calories)}</text>
        <text x="50" y="58" textAnchor="middle" className="text-[7px]" fill="#64748b">kcal</text>
      </svg>
      <span className="text-[10px] font-semibold text-slate-600 text-center leading-tight">{label}</span>
      <div className="flex gap-2 text-[8px] text-slate-400">
        <span className="text-blue-500">{pL}:{protein.toFixed(0)}g</span>
        <span className="text-amber-500">{kL}:{carbs.toFixed(0)}g</span>
        <span className="text-rose-500">{fL}:{fat.toFixed(0)}g</span>
      </div>
    </div>
  );
}
